import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store";
import axios from "axios";
import constants from "./constants";

const isPublic = sessionStorage.getItem("isPublic");

axios.defaults.baseURL = isPublic
  ? constants.DEFAULT_URL_PUBLIC
  : constants.DEFAULT_URL;

axios.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");
    const user = sessionStorage.getItem("userCode");
    if (token && user) {
      config.headers["X-Authorization"] = token;
      config.headers["X-User"] = user;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
